import * as fromDatatype from "../datatype-library/index";

export interface bl_mkp_mst_item_attribute_child_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  mkp_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  mkp_item__line_guid: fromDatatype.GuidDataFieldInterface;
  attribute_set_hdr_guid: fromDatatype.GuidDataFieldInterface;
  attribute_hdr_guid: fromDatatype.GuidDataFieldInterface;
  ecomsync_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  ecomsync_item_line_guid: fromDatatype.GuidDataFieldInterface;
  attribute_code: fromDatatype.VarcharDatatypeInterface;
  atrribute_name: fromDatatype.VarcharDatatypeInterface;
  source_type: fromDatatype.VarcharDatatypeInterface;
  value_type: fromDatatype.VarcharDatatypeInterface;
  value_string: fromDatatype.VarcharDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_mkp_mst_item_attribute_child_link_RowClass implements bl_mkp_mst_item_attribute_child_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  mkp_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  mkp_item__line_guid: fromDatatype.GuidDataFieldInterface;
  attribute_set_hdr_guid: fromDatatype.GuidDataFieldInterface;
  attribute_hdr_guid: fromDatatype.GuidDataFieldInterface;
  ecomsync_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  ecomsync_item_line_guid: fromDatatype.GuidDataFieldInterface;
  attribute_code: fromDatatype.VarcharDatatypeInterface;
  atrribute_name: fromDatatype.VarcharDatatypeInterface;
  source_type: fromDatatype.VarcharDatatypeInterface;
  value_type: fromDatatype.VarcharDatatypeInterface;
  value_string: fromDatatype.VarcharDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
